<div class="repeat" [style.max-height]="field.props.maxHeight">
  @for (fi of field.fieldGroup; track $index; let i = $index) {
    <div class="row position-relative">
      <formly-field [field]="fi"></formly-field>
      <div class="col-2 d-flex align-items-center position-absolute top-0 end-0">
        @if (props.tenderDetail().authorizationState?.isProjectManagerOrDeputy) {
          <button mat-icon-button (click)="this.props.editItem(fi, i)" color="primary">
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (props.tenderDetail().state === tenderStates.Incomplete || isInWizard) {
          <button mat-icon-button (click)="this.props.removeItem(field, i)" color="warn">
            <mat-icon>delete_forever</mat-icon>
          </button>
        }
      </div>
    </div>
  }
</div>

@for (validate of validatedTenderInfo(); track validate.translateKey) {
  <mat-card class="mb-2">
    <div class="d-flex text-danger justify-center align-center flex-column text-center">
      <div>
        <strong> {{ validate.translateKey | translate }} </strong>
      </div>
      <div>
        <ul>
          @for (names of validate.groupNames; track $index) {
            <li>{{ names }}</li>
          }
        </ul>
      </div>
    </div>
  </mat-card>
}

@if (props.tenderDetail().state === tenderStates.Incomplete || isInWizard) {
  @if (field.props.allowAdd !== false) {
    <button
      class="mt-2"
      mat-raised-button
      (click)="add(undefined, this.props.initializeNewAssessmentTeam ? this.props.initializeNewAssessmentTeam() : undefined)"
    >
      {{ field.props.addLabel | translate }}
    </button>
  }
}
